var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4131_27908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9672 6.4502H9.01367V17.1083H14.9672V6.4502Z",
    fill: "#FF5A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41073 11.7793C9.41073 9.61385 10.4323 7.69195 12 6.45019C10.8463 5.54629 9.39091 5 7.80343 5C4.04283 5 1 8.03201 1 11.7793C1 15.5265 4.04283 18.5585 7.80343 18.5585C9.39091 18.5585 10.8463 18.0122 12 17.1083C10.4301 15.8841 9.41073 13.9447 9.41073 11.7793Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 11.7793C23 15.5265 19.9572 18.5585 16.1966 18.5585C14.6091 18.5585 13.1537 18.0122 12 17.1083C13.5875 15.8644 14.5893 13.9447 14.5893 11.7793C14.5893 9.61385 13.5677 7.69195 12 6.45019C13.1515 5.54629 14.6069 5 16.1943 5C19.9572 5 23 8.05178 23 11.7793Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4131_27908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 13.5385,
    fill: "white",
    transform: "translate(1 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.7d1f8177af5e4fd78ede17ab057d3cf2.svg";
export { ForwardRef as ReactComponent };